import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import { Segment, Container } from 'semantic-ui-react'

import { getExternalLinks } from 'stores/Links/Select'
import { items } from './items.ehr'
import { useRouter } from 'next/router'

import MyHealthTopBanner from './components/MyHealthTopBanner'
import MyHealthTabSelection from './components/MyHealthTabSelection'
import MyHealthContentArea from './components/MyHealthContentArea'
import MyHealthBottomBanner from './components/MyHealthBottomBanner'
import mergeStyles from '@web/helpers/mergeStyles'

import { useTheme } from 'contexts/ThemeProvider'
import localization from './localization'
import { getCurPatientData } from '@web/stores/Account/Select'
import useMyHealthPolicyByModel from 'hooks/useMyHealthPolicy'
import useHandleRequest from 'hooks/useHandleRequest'
import themeStyles from './styles'
import withLocalization from '@web/helpers/localizationUtils'

const DEFAULT_HEALTH_ITEM = 'testResults'

const UnavailableMessageComponent = ({ style, t }) => {
  const { theme } = useTheme()
  const styles = themeStyles(theme)
  const mergedStyles = mergeStyles(styles, style)
  const links = _.merge({}, ...Object.values(useSelector(getExternalLinks)))

  return (
    <Segment style={mergedStyles.unavailableMessage}>
      <div style={mergedStyles.message}>
        {`${t('unavailableMessage')} `}
        <a
          href={_.get(links, 'UFD_Restricted_Text')}
          target='_blank'
          rel='noreferrer'
        >
          <u>{t('learnMore')}</u>
        </a>
      </div>
    </Segment>
  )
}

export const UnavailableMessage = withLocalization(
  UnavailableMessageComponent,
  localization
)

const MyHealth = ({ t }) => {
  const [isAdolescent, setIsAdolescent] = useState(false)
  const { theme } = useTheme()
  const styles = themeStyles(theme)
  const patientDetails = useSelector(getCurPatientData)
  const patientId = _.get(patientDetails, 'patientId')
  const router = useRouter()
  const id = _.get(router.query, 'id', DEFAULT_HEALTH_ITEM)
  const handleRequest = useHandleRequest()
  const isUser = _.get(patientDetails, 'isUser', false)

  const itemStates = items
    .filter(item => item.name !== id)
    .map(item => ({
      // eslint-disable-next-line react-hooks/rules-of-hooks
      loading: useSelector(item.selectors.loading),
      // eslint-disable-next-line react-hooks/rules-of-hooks
      json: useSelector(item.selectors.json),
      request: item.request,
      queryFHIR: item.queryFHIR,
      name: item.name,
      // eslint-disable-next-line react-hooks/rules-of-hooks
      isAccessable: useMyHealthPolicyByModel(item.name)
    }))
  useEffect(
    () => {
      itemStates.forEach(item => handleRequest(item))
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [patientId, isUser]
  )

  useEffect(() => {
    document.body.style.backgroundColor = theme.textWhite
    return () => {
      document.body.style.backgroundColor = theme.whiteSmoke
    }
  }, [theme])
  return (
    <Segment style={styles.container} vertical className='myHealth'>
      <MyHealthTopBanner />
      {isAdolescent && <UnavailableMessage t={t} />}
      <Container style={styles.content}>
        <MyHealthTabSelection />
        <MyHealthContentArea setIsAdolescent={setIsAdolescent} />
      </Container>
      <MyHealthBottomBanner />
    </Segment>
  )
}

export default withLocalization(MyHealth, localization)
